import { useEffect, useRef } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useDocumentTitle } from '@/shared/hooks/useDocumentTitle'
import { useToast } from '@/shared/toast/ToastProvider'
import { readPasswordResetSuccessFromState } from '../lib'
import { SP_FORGOT_PASSWORD_LOGIN_SUCCESS_MESSAGE } from '../lib/password-messages'

/** TC-SPW3-24 — redirect to login with toast (no intermediate success card). */
export function ResetPasswordSuccessPage() {
  useDocumentTitle('Password Changed')
  const navigate = useNavigate()
  const location = useLocation()
  const { showToast } = useToast()
  const allowed = readPasswordResetSuccessFromState(location.state)
  const toastShownRef = useRef(false)

  useEffect(() => {
    if (!allowed) {
      navigate('/reset-password', { replace: true })
      return
    }
    if (!toastShownRef.current) {
      toastShownRef.current = true
      showToast(SP_FORGOT_PASSWORD_LOGIN_SUCCESS_MESSAGE, 'success')
    }
    navigate('/login', { replace: true })
  }, [allowed, navigate, showToast])

  return null
}
